<script>
import AddressForm from "./AddressForm.vue";

export default {
  props: {
    addressesCount: {
      required: true,
      type: Number
    }
  },

  data() {
    return {
      shippingAddressId: this.shippingOpen(),
      billingAddressId: window.__FORM__ && window.__FORM__.billingAddressId || 'new'
    }
  },

  methods: {
    shippingOpen() {
      if (window.__FORM__ && window.__FORM__.shippingAddressId) {
        return window.__FORM__.shippingAddressId
      }

      if (this.addressesCount > 0) {
        return 1
      }

      return 'new'
    }
  },

  components: {
    AddressForm
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/shop/AddressFieldset.vue